import React, { Component } from "react";
import { Spinner } from "react-bootstrap";

export default class Loading extends Component {

  render() {
    return (
      <div className="col-sm">
        <div className="text-primary">
          <h6 className="text-center">
          <div className="mt-5"/>
          <Spinner animation="grow" className="text-primary spinner-big" /> 
          <div className="mt-5"/>
          {this.props.msg ? this.props.msg : "Loading..."} 
          </h6>
        </div>
      </div>
    );
  }
}
